/*
 * @Author: fengxiaojing
 * @LastEditTime: 2022-09-09 15:33:30
 * @Description:
 * @LastEditors: Please set LastEditors
 */
export default {
  Document: 'Document',
  parseFileNameAddDocument: 'Parse File Name Add Document',
  SearchForDocumentNameOrEncoding: 'Search for Doc Name or Encoding',
  RecursiveDisplay: 'Recursive Display',
  AdvancedSearch: 'Advanced Search',
  transfer: 'Transfer',
  DownloadTheFileAssociatedWithTheDocument: 'Download the File Associated With the Doc',
  directoryTree: 'Directory Tree',
  Pleasesearchforthename: 'Please Search for The Name',
  documentEncoding: 'Code',
  documentName: 'Name',
  documentCategory: 'Category',
  Version: 'Version',
  state: 'State',
  creationTime: 'Creation Time',
  createUser: 'Create User',
  LastModified: 'Last Modified',
  LastModifiedUser: 'Last Modified User',
  ScheduledDeliveryTime: 'Scheduled Delivery Time',
  ActualDeliveryTime: 'Actual Delivery Time',
  BrowseDocumentObjects: 'Browse Doc Asset',
  upgrade: 'Upgrade',
  historicVersion: 'Historic Version',
  addFolder: 'Add Folder',
  FolderName: 'Folder Name',
  BulkAddFolders: 'The System Supports Adding Folders in Batches, One for Each Row',
  editFolder: 'Edit Folder',
  FolderPath: 'Folder Path',
  editDocument: 'Edit Doc',
  BasicProperties: 'Basic Properties',
  coding: 'Coding',
  path: 'Path',
  category: 'Category',
  TemplateProperties: 'Template Properties',
  connectionRelation: 'Connection Relation',
  updateAll: 'Update All',
  updateSelected: 'Update Selected',
  setDefaultFile: 'Set Default File',
  fileName: 'File Name',
  defaultFile: 'Default File',
  enterTitle: 'Enter Title',
  addAssociation: 'Add Association',
  WhetherToDisassociate: 'Whether to Disassociate',
  objectName: 'Object Name',
  Disassociate: 'Disassociate',
  AssociatedDocuments: 'Associated Documents',
  AddAssociatedDocuments: 'Add Associated Documents',
  enterATagCodeOrName: 'Please Enter a Tag Code or Name',
  enterAnAlias: 'Please Enter an Alias',
  AddDocument: 'Add Doc',
  DownloadProgress: 'Download Progress',
  HistoryUpgrade: 'History Upgrade',
  DocumentationUpgrade: 'Documentation Upgrade',
  Uploader: 'Uploader',
  UploadTime: 'Upload Time',
  documentStatus: 'Doc Status',
  DownloadDistoricalVersionFiles: 'Download Historical Version Files',
  documentHandover: 'Doc Handover',
  ProcessApproval: 'Process Approval',
  ProcessType: 'Process Type',
  ProcessStatus: 'Process Status',
  Reviewer: 'Reviewer',
  DocumentationDirectory: 'Documentation Directory',
  deadline: 'Deadline',
  handoverDocuments: 'Handover Documents',
  ManualAssociation: 'Manual Association',
  uploadFiles: 'Upload Files',
  fileUploadProcessing: 'File Upload Processing',
  PleaseSelectACategory: 'Please Select a Category',
  NotHandedOver: 'Not Handed Over',
  underReview: 'Under Review',
  handedOver: 'Handed Over',
  PleaseEnterCode: 'Please Enter Code',
  PleaseEnterAName: 'Please Enter a Name',
  PleaseSelectAPath: 'Please Select a Path',
  PleaseEnterVersion: 'Please Enter Version',
  LengthCannotExceedTenCharacters: 'Length Cannot Exceed 10 Characters',
  PleaseFnterAFolderName: 'Please Enter a Folder Name',
  PleaseEnterTheFolderPath: 'Please Enter the Folder Path',
  PleaseEnterATitle: 'Please Enter a Title',
  PleaseSelectAProcessType: 'Please Select a Process Type',
  PleaseSelectADocumentDirectory: 'Please Select a Doc Directory',
  PleaseSelectATime: 'Please Select a Time',
  fileCode: 'File Code',
  PleaseSelectAnAssociatedFile: 'Please Select an Associated File',
  TheAssociatedFileIsSuccessful: 'The Associated File is Successful',
  PleaseSelectADocumentToLink: 'Please Select a Doc to Link',
  DisassociationSucceeded: 'Disassociation Succeeded',
  UploadedSuccessfully: 'Uploaded Successfully',
  SecondPassIsSuccessful: 'Second Pass is Successful',
  TheTreeVodeNameCannotBeTheSamepleaseRe_enter:
    'The Tree Node Name Cannot be The Same, Please Re-Enter',
  AreYouSureYouWantToDeleteTheCorrespondingDirectory:
    'Are You Sure You Want to Delete The Corresponding Directory',
  DeleteDirectoriesAndDirectories:
    'This Directory Contains Documents. If You Delete it Forcibly, The Documents in This Directory Will be Deleted. Are You Sure You Want to Delete the Selected Directory',
  addedSuccessfully: 'Added Successfully',
  successfullyDeleted: 'Successfully Deleted',
  SuccessfullyModified: 'Successfully Modified',
  WhetherToDeleteTheCheckedData: 'Whether to Delete The Checked Data',
  WhetherToDelete_filteredData:
    'Whether to Delete (Automatically Filtered Data Under Review And Handed Over)',
  PleaseTickTheDeletedItem: 'Please Tick The Deleted Item',
  RequiredFieldsAreNotFilled: 'Required Fields are Not Filled',
  PleaseCheckTheFileAndThenSetTheDefaultFile: 'Please Check The File and Then Set The Default File',
  OnlyOneDefaultFileCanBeSet: 'Only One Default File Can be Set',
  SetDefaultFileSuccessfully: 'Set Default File Successfully',
  PleaseClickTheFileListOnTheLeft: 'Please Click The File List on The Left',
  PleaseConfirmIfYouWantToContinue: 'Please Confirm If You Want to Continue',
  SuccessfulOperation: 'Successful Operation',
  NoRecordsAreCurrentlySelected: 'No Records are Currently Selected',
  PleaseSelectAnObjectNotHandedOver: 'Please Select an Asset Not Handed Over',
  DocumentDataUnderReviewAndHandedOverHasBeenAutomaticallyFiltered:
    'Doc Data Under Review and Handed Over Has been Automatically Filtered',
  DocumentHandoverProcess: 'Doc Handover Process',
  at: 'At',
  InitiateProcess: 'Initiate Process',
  DocumentPublishingProcess: 'Doc Publishing Process',
  ReviewerCannotBeEmpty: 'Reviewer Cannot be Empty',
  ruleExpression: 'rule expression：',
  enterRuleExpression:
    "The document attributes enclosed in curly braces and the connectors in single quotes, such as: {code}'splicing rules'{name}'splicing rules'{Revision}",
  enterRightRuleExpression: 'please enter the right rule expression',
  compareVersions: 'compare versions',
  checkIn: 'check in',
  checkOut: 'check out',
}
